import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import manageBodyOverflow from '../../utils/manageBodyOverflow';

const MobileMenuClose = styled.button`
  background: ${(props) => props.theme.color.brand};
  color: ${(props) => props.theme.color.white};
  border: none;
  font-size: ${(props) => props.theme.modularScale.sixteen};
  font-family: ${(props) => props.theme.font.sans};
  border-bottom: 1rem solid ${(props) => props.theme.color.brand};
  cursor: pointer;
  width: 100%;
  padding: 1.2rem 1.2rem .2rem;
  margin-top: auto;
  position: sticky;
  bottom: 0;
  z-index:  ${(props) => props.theme.layers.box};
`;

const MobileMenu = styled.div`
  background: ${(props) => props.theme.color.white};
  visibility: hidden;
  height: 100%;
  left: 0;
  overflow: scroll;
  padding: 0.8rem;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  transform: translate(0, -100%);
  transition: transform ${(props) => props.theme.animation.fast} ${(props) => props.theme.animation.easeOutQuad};
  width: 100%;
  z-index: -1;

  > section {
    padding-bottom: 2.4rem;
  }

  ${(props) => props.isOpened && css`
    visibility: visible;
    transform: translate(0, 0);
    z-index: ${props.theme.layers.box + 2};
  `}
`;

const MobileModal = (props) => {
  /**
   * TODO: Top blue banner should be behind the filters when active
   */
  const closeModalRef = useRef(null);

  useEffect(() => {
    const closeButton = closeModalRef.current;

    if (closeButton) closeButton.focus();

    manageBodyOverflow(props.isOpened);
  }, [props.isOpened]);

  return (
    <MobileMenu className={props.className} isOpened={props.isOpened}>
      {props.children}
      <MobileMenuClose ref={closeModalRef} aria-label="close modal" type="button" onClick={props.onClose}>
        Done
      </MobileMenuClose>
    </MobileMenu>
  );
};

MobileModal.defaultProps = {
  className: ''
};

MobileModal.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  isOpened: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default MobileModal;
